<template>
  <!-- Dropzone reutilizable a pantalla completa (DXF/DWG). El botón "volver" va
       FUERA del <b-upload> (hermano, posicionado) para que clicar el área de drop
       NO pueda dispararlo — así se evita la interferencia de Buefy. -->
  <div class="relative flex-1 p-4">
    <b-upload
      class="dz-upload w-full h-full"
      :value="value"
      drag-drop
      :accept="accept"
      @input="$emit('epc-file', $event)">
      <div class="flex flex-col items-center gap-2.5 p-6 text-center select-none">
        <svg class="mb-1" width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="6" y="6" width="76" height="76" rx="18" fill="#F1F5F9"/>
          <path d="M28 57H23C17.477 57 13 52.523 13 47C13 41.7 17.12 37.37 22.33 37.03C24.15 27.4 32.6 20 42.75 20C53.6 20 62.45 28.45 63 39.16C69.78 39.67 75 45.2 75 52C75 59.18 69.18 65 62 65H54" stroke="#64748B" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M44 40V67M33 56L44 67L55 56" stroke="#64748B" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p class="text-xl font-bold text-slate-700">{{ $t('drop_design_here') }}</p>
        <p class="text-[13px] text-slate-400">{{ $t('drop_design_hint') }}</p>
      </div>
    </b-upload>

    <!-- Botón "volver": hermano del b-upload, independiente del área de drop. -->
    <button
      v-if="showBack"
      type="button"
      class="absolute left-1/2 bottom-10 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-lg border border-[#3a6bc8] bg-white px-3.5 py-1.5 text-[13px] font-semibold text-[#3a6bc8] transition-colors hover:bg-[#3a6bc8] hover:text-white"
      @click="$emit('epc-back')">
      <b-icon pack="fas" icon="arrow-left" size="is-small"></b-icon>
      <span>{{ $t('back') }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'WidgetDropzone',

  props: {
    /** v-model del archivo (se pasa a b-upload). */
    value:    { type: [Object, File], default: null },
    /** Extensiones aceptadas. */
    accept:   { type: String, default: '.dxf,.dwg' },
    /** Muestra el botón "volver". */
    showBack: { type: Boolean, default: true },
  },
}
</script>

<style scoped>
/* Buefy renderiza el área de drop como .upload-draggable (internal) → Tailwind no
   llega; lo estilamos con :deep (único CSS custom necesario). */
.dz-upload,
.dz-upload :deep(.upload-draggable) {
  width: 100%;
  height: 100%;
}

.dz-upload :deep(.upload-draggable) {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  background-color: #fafbfc;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.dz-upload :deep(.upload-draggable:hover) {
  border-color: #3a6bc8;
  background-color: #f4f7fd;
}
</style>
